import React from 'react';
import './NumberTaxiForSellPage.css';
import { Helmet } from 'react-helmet';
import NumberTaxiForSaleTable from '../../components/NumberTaxiTables/NumberTaxiForSaleTable';
import Ads1200100 from "../../components/Ads1200100/Ads1200100";
import AdsMoshezion from '../../components/Ads/AdsMoshezion/AdsMoshezion';
import NewTaxisHomePageCards from "../../components/NewTaxisHomePageCards/NewTaxisHomePageCards";
import ArticlesPreview from "../../components/ArticlesPreviewBlog/ArticlesPreviewBlog";
import { FaWhatsapp } from "react-icons/fa"
const NumberTaxiForSellPage = () => {
  return (
    <>
    <Helmet>
  {/* Title & Description */}
  <title>זכויות ציבוריות למכירה | BuyTaxi - קנה ומכור זכויות ציבוריות בקלות</title>
  <meta name="description" content="זכויות ציבוריות למכירה לכל סוגי המוניות! פרסום חינם, חשיפה לנהגים ורוכשים מכל הארץ. קנה או מכור זכויות ציבוריות בקליק עם BuyTaxi - המקום של נהגי המוניות בישראל!" />

  {/* Open Graph Meta Tags */}
  <meta property="og:title" content="זכויות ציבוריות למכירה | BuyTaxi | קנה טקסי" />
  <meta property="og:description" content="BuyTaxi - מציע לך פלטפורמה חינמית למכירה ורכישת זכויות ציבוריות למוניות. אל תפספס את ההזדמנות שלך!" />
  <meta property="og:image" content="%PUBLIC_URL%/og-image.jpg" />
  <meta property="og:url" content="https://buytaxi.co.il/NumberTaxiForSell" />
  <meta property="og:type" content="website" />

  {/* Twitter Meta Tags */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="זכויות ציבוריות למכירה | BuyTaxi" />
  <meta name="twitter:description" content="לוח הזכויות הציבוריות הגדול בישראל. פרסם בחינם וקבל לידים איכותיים מקונים אמיתיים!" />
  <meta name="twitter:image" content="%PUBLIC_URL%/og-image.jpg" />
  <meta name="twitter:site" content="@buytaxi" />

  {/* SEO Keywords */}
  <meta name="keywords" content="זכויות ציבוריות למכירה, זכות ציבורית, מכירת זכות ציבורית, רכישת זכות ציבורית, רישיון מונית, תחנות מוניות, לוח זכויות ציבוריות, לוח מוניות, קניית מוניות, מונית למכירה, קנה טקסי, BuyTaxi, ליסינג מוניות, ליסינג למונית, ביטוח מוניות, לוח נהגים, תיווך מוניות, השקעה בזכויות ציבוריות, נהג מונית עצמאי, מונית חדשה, מונית יד שניה, קניית זכות, מכירת זכות, שוק המוניות, עסק מוניות, הכנסה ממונית, מונית ספיישל, מספר ציבורי למכירה, לוח מספרים ציבוריים, מספר מונית למכירה, מספר צהוב למכירה, מספר ציבורי להשכרה, לוח מספרי מוניות, שווי זכות ציבורית, מחיר זכות ציבורית, איך מוכרים זכות ציבורית, נהג עם מספר ציבורי, תעודת מונית, שוק הזכויות הציבוריות" />

  {/* Canonical URL */}
  <link rel="canonical" href="https://buytaxi.co.il/NumberTaxiForSell" />
</Helmet>

      <div className='NumberTaxiForSellPageContiner'>
        <div className='BigAds'>
          <Ads1200100 />
        </div>
        <div className='NumberTaxiForSellPage-table'>
  <div className="NumberTaxiForSellPage-table-section">
    <NumberTaxiForSaleTable />
  </div>
  <div className="NumberTaxiForSellPage-banner-section">
    <AdsMoshezion />
  </div>
</div>
  <div className='FreePublishSendWhatsappNumberForRent'>
    <a
      href="https://wa.me/972502268395?text=היי%20מעוניין%20לפרסם%20זכות%20ציבורית%20באתר%20קנה%20טקסי"
      target="_blank"
      rel="noopener noreferrer"
      className="FreePublishSendWhatsappNumberForRent-link"
    >
      <div className="FreePublishSendWhatsappNumberForRent-header">
        <h2 className='FreePublishSendWhatsappNumberForRenth2'>פרסם בחינם</h2>
        <div className="FreePublishSendWhatsappNumberForRent-button">
          <FaWhatsapp className="whatsapp-icon" />
        </div>
      </div>
      <p className="FreePublishSendWhatsappNumberForRent-subtext">
        שלחו את הפרטים בוואטספ והופ זה באוויר
      </p>
    </a>
  </div>
<div className='NumberTaxiForSellPage-NewTaxisHomePageCards'>
  <NewTaxisHomePageCards />
  </div>
  <div className="ArticlesPreviewNumberTaxiForRentPage">
  <ArticlesPreview />
</div>
      </div>
      </>
  );
};

export default NumberTaxiForSellPage;
